import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UnidadeService } from "src/app/shared/services/unidade.service";
import { deleteUnidade, editUnidade, editUnidadeError, editUnidadeSuccess, loadUnidade, loadUnidadeError, loadUnidadeSuccess, saveUnidade, saveUnidadeError, saveUnidadeSuccess } from "./unidade.actions";
import { catchError, concatMap, exhaustMap, map, of, tap } from "rxjs";
import { NotifyService } from "src/app/shared/services/notify.service";
import { UserService } from "src/app/shared/services/user.service";

@Injectable()

export class UnidadeEffects {

    constructor(
        private service: UnidadeService,
        private unitService: UnidadeService,
        private action$: Actions,
        private notify: NotifyService,
    ) { }

    loadUnidade$ = createEffect(() =>
        this.action$.pipe(
            ofType(loadUnidade),
            exhaustMap(() =>
                this.unitService
                    .getAll()
                    .pipe(
                        map((res) => loadUnidadeSuccess({ lista: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(loadUnidadeError())
                        })
                    )
            )
        )
    )

    saveUnidade$ = createEffect(() =>
        this.action$.pipe(
            ofType(saveUnidade),
            concatMap(({ unidade }) =>
                this.service
                    .save(unidade)
                    .pipe(
                        tap(() => this.notify.saveSuccess()),
                        map((res) => saveUnidadeSuccess({ unidade: res })),
                        catchError((error) => {
                            if (error?.error.id) {
                                this.notify.emitWarn('Cadastro Realizado com sucesso, mas existem pendencias, conferir dashboard')
                            } else {
                                this.notify.emitError(error?.error?.error)
                            }
                            return of(saveUnidadeError({ error: error?.error }))
                        }))
            )
        )
    )

    editUnidade$ = createEffect(() =>
        this.action$.pipe(
            ofType(editUnidade),
            concatMap(
                ({ unidade, id }) =>
                    this.service
                        .editUnidade(unidade, id)
                        .pipe(
                            tap(() => this.notify.editSuccess()),
                            map((res) => editUnidadeSuccess({ unidade: res })),
                            catchError((error) => {
                                if (error?.error.id) {
                                    this.notify.emitWarn('Cadastro Realizado com sucesso, mas existem pendencias, conferir dashboard')
                                } else {
                                    this.notify.emitError(error?.error?.error)
                                }
                                return of(editUnidadeError());
                            })
                        )
            )
        )
    );

    deleteUnidade$ = createEffect(() =>
        this.action$.pipe(
            ofType(deleteUnidade),
            concatMap(
                ({ id }) =>
                    this.service
                        .delete(id)
                        .pipe(
                            tap(() => this.notify.deleteSuccess()),
                            map((res) => loadUnidade()),
                            catchError((error) => {
                                this.notify.emitError(error.error['hydra:description'])
                                return of(error.error['hydra:description']);
                            })
                        )
            )
        )
    );
}